const parseInputMoneyMYR = (value: any) => {
  const raw = String(value ?? "").trim();
  if (raw === "") return 0;

  const isNegative = raw.startsWith("-");
  const sign = isNegative ? -1 : 1;

  const normalized = raw.replace(/,/g, "").replace(/[^0-9.]/g, "");
  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed * sign : 0;
};

export default parseInputMoneyMYR;
